import { render } from "./InviteAccept.vue?vue&type=template&id=30d3a88f&scoped=true"
import script from "./InviteAccept.vue?vue&type=script&lang=js"
export * from "./InviteAccept.vue?vue&type=script&lang=js"

import "./InviteAccept.vue?vue&type=style&index=0&id=30d3a88f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30d3a88f"]])

export default __exports__